export default __webpack_public_path__ + "static/media/S4xCLUES2.940edba3.jpg";